import { render, staticRenderFns } from "./PayBarCode.vue?vue&type=template&id=4539e2dc"
import script from "./PayBarCode.vue?vue&type=script&lang=js"
export * from "./PayBarCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4539e2dc')) {
      api.createRecord('4539e2dc', component.options)
    } else {
      api.reload('4539e2dc', component.options)
    }
    module.hot.accept("./PayBarCode.vue?vue&type=template&id=4539e2dc", function () {
      api.rerender('4539e2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/PayBarCode.vue"
export default component.exports